import classNames from 'classnames';

import styles from './RadioInput.module.scss';

type RadioButtonProps = {
  name: string;
  value: string;
  selectedValue?: string;
  onChange?: (value: string) => void;
  className?: string;
};

const RadioInput = ({
  name,
  value,
  selectedValue,
  onChange,
  className,
}: RadioButtonProps) => {
  return (
    <label className={classNames(styles.radio, className)}>
      <input
        name={name}
        type="radio"
        value={value}
        onChange={(event) => {
          onChange && onChange(event.target.value);
        }}
        checked={selectedValue === value}
      />
      <span className={styles.checkmark} />
    </label>
  );
};

export default RadioInput;
